export const APP_VERSION = '0.0.2'

export const DOWNLOAD_URL =
  'https://docs.google.com/uc?export=download&id=1o5mAY38b9o-dpl5XD5ga-Z4gAihKFjNM'

export const MANUAL_URL =
  'https://www.notion.so/247f5fab996980b7a98de5f70bc80935?v=247f5fab9969800b969f000cd7f86be6'

export const SUPPORT_URL = 'https://smartstore.naver.com/noziz'
